import React, { useEffect, useState } from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import InputMask from "react-input-mask";
import TextField from "@mui/material/TextField";
import { useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import api from "../../api";
import Alert from "@mui/material/Alert";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const Create = (args) => {
  const token = useSelector((state) => state.userSelector.token);
  const [install_time, setInstall_time] = useState(null);
  const [schedule_time, setSchedule_time] = useState(null);
  const [type, setType] = useState(null);
  const [user, setUser] = useState(null);
  const [name, setName] = useState(null);
  const [company, setCompany] = useState(null);
  const [number, setNumber] = useState(null);
  const [email, setEmail] = useState(null);
  const [userMask, setUserMask] = useState("СО*№**************");
  const [gender, setGender] = useState(true);
  const [location, setLocation] = useState(null);
  const [address, setAddress] = useState(null);
  const [referral, setReferral] = useState(null);
  const [notification, setNotification] = useState(null);
  const [userTarifValidation, setUserTarifValidation] = useState(false);
  const statistics = useSelector((state) => state.userSelector.statistics);
  const [expanded, setExpanded] = useState(false); // Add this state
  const [dialogOpen, setDialogOpen] = useState(false);
  const [errors, setErrors] = useState({});

  // Add this function to handle accordion expansion
  const handleAccordionChange = () => {
    setExpanded(!expanded);
  };

  const handleDownload = () => {
    api.downloadClients(
      token,
      args.type,
      args.searchQuery,
      args.dateFrom,
      args.dateTo,
    );
  };

  const createClientFunc = () => {
    const newErrors = {};

    if (!install_time) newErrors.install_time = true;
    if (args.type === "law" && !schedule_time) newErrors.schedule_time = true;
    if (!user) newErrors.user = true;
    if (args.type !== "law" && !name) newErrors.name = true;
    if (!number) newErrors.number = true;
    if (!email) newErrors.email = true;
    if (args.type !== "law" && !location) newErrors.location = true;
    if (!address) newErrors.address = true;
    if (args.type !== "law" && !referral) newErrors.referral = true;

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }
    // let user_ = user.replaceAll("_", "");
    let client = {
      install_time: install_time,
      type: type,
      user: user,
      name: name,
      company: company,
      number: number,
      email: email,
      location: location,
      gender: gender,
      address: address,
      referral: referral,
    };
    client["schedule_time"] = schedule_time;
    if (args.type === "law") {
      // client['schedule_time'] = schedule_time
      client["law"] = true;
    }
    // console.log(user);
    api
      .postClient(token, client)
      .then((response) => {
        setInstall_time(null);
        setSchedule_time(null);
        setType(null);
        setUser("");
        setName("");
        setCompany("");
        setNumber("");
        setEmail("");
        setGender(true);
        setLocation("");
        setAddress("");
        setReferral("");
        setNotification(null);
        args.getClientsFunc();
      })
      .catch((error) => {
        if (error.response.status === 400) {
          setNotification("Договор уже существует");
        }
      });
  };

  useEffect(() => {
    if (user) {
      let prefix = user.split("№")[0];
      if (prefix === "СО5") {
        setUserTarifValidation(false);
        setType("so5");
      } else if (prefix === "СО8") {
        setUserTarifValidation(false);
        setType("so8");
      } else if (prefix === "СО10") {
        setUserTarifValidation(false);
        setType("so10");
      } else if (user.includes("RZN-S-")) {
        setUserTarifValidation(false);
        setType("RZN-S-");
      } else {
        setUserTarifValidation(true);
      }
    }
  }, [user]);

  // const userCodeHandler_law = (e) => {
  //   let value = e.target.value.replace(" ", "/");
  //   setUserMask("*****№**************");
  //   setUser(value);
  //   let prefix = value.split("№")[0];
  //   if (prefix === "RZN-S") setType("RZN-S");
  //   else setType("so10");
  // };

  const userCodeHandler = (e) => {
    let prefix = e.target.value.split("№")[0];
    let value = e.target.value.replace(" ", "/");
    if (prefix === "СО1" || prefix === "СО10" || prefix === "СО1_") {
      setUserMask("СО**№**************");
      setUser(value);
    } else if (e.target.value.includes("RZN-S-")) {
      setUserMask("RZN-S-*****");
      setUser(value);
    } else {
      setUserMask("СО*№**************");
      setUser(value);
    }
  };
  // const userCodeHandler = (e) => {
  //   let prefix = e.target.value.split("№")[0];
  //   let value = e.target.value.replace(" ", "/");
  //   if (prefix === "RZN-S") {
  //     setUserMask("RZN-S№**************");
  //     setUser(value);
  //   } else {
  //     setUserMask("СО10№**************");
  //     setUser(value);
  //   }
  // };

  const formatNumber = (num) => {
    return Math.round(num)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  return (
    <Accordion
      className={`getMainCreate ${args.type === "law" && "getMainCreateLaw"}`}
      expanded={expanded}
      onChange={handleAccordionChange}
    >
      <div className="filtrDiv">
        <Typography
          className="createClientTypograpyh"
          onClick={handleAccordionChange}
        >
          {!expanded ? `+` : "-"}
        </Typography>
        <TextField
          className="searchInput"
          value={args.searchQuery}
          onChange={(e) => {
            args.setSearchQuery(e.target.value);
            args.setPage(1);
          }}
          onfo
          id="name-basic"
          label="Поиск"
          variant="outlined"
        />

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TextField
            type="date"
            sx={{ maxWidth: "150px", minWidth: "150px", marginTop: "8px" }}
            className={`datetimepicker dateFromTo ${
              args.dateFrom && "dateValue"
            }`}
            format="DD/MM/YYYY"
            ampm={false}
            value={args.dateFrom ? args.dateFrom : null}
            id="install_time"
            onChange={(e) => args.setDateFrom(e ? e.target.value : null)}
            label="Дата от"
          />

          <TextField
            type="date"
            sx={{ maxWidth: "150px", minWidth: "150px", marginTop: "8px" }}
            className={`datetimepicker dateFromTo ${
              args.dateTo && "dateValue"
            }`}
            format="DD/MM/YYYY"
            ampm={false}
            value={args.dateTo ? args.dateTo : null}
            id="install_time"
            onChange={(e) => args.setDateTo(e ? e.target.value : null)}
            label="Дата до"
          />
        </LocalizationProvider>
        {args.type !== "law" && (
          <Typography
            className="statisticButton"
            onClick={(е) => setDialogOpen(true)}
          >
            Статистика
          </Typography>
        )}
        <Typography className="statisticButton" onClick={handleDownload}>
          Скачать базу
        </Typography>

        <p>Станции: {statistics && statistics.client_count}</p>
        <p>Доход: {statistics && formatNumber(statistics.monthly_income)} ₽</p>

        <Dialog
          open={dialogOpen}
          className="statisticDialog"
          onClose={(е) => setDialogOpen(false)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle>Статистика</DialogTitle>
          <DialogContent>
            <div className="statisticDiv">
              {!args.statistics && (
                <div className="statisticDiv">
                  <div className="statBlock">
                    <h4>Трафик:</h4>
                    {statistics &&
                      statistics.referral &&
                      Object.entries(statistics.referral).map(
                        ([key, value]) => (
                          <p key={key}>
                            {key}: {value}
                          </p>
                        ),
                      )}
                  </div>

                  <div className="statBlock">
                    <h4>Районы:</h4>
                    {statistics &&
                      statistics.location &&
                      Object.entries(statistics.location).map(
                        ([key, value]) => (
                          <p key={key}>
                            {key}: {value}
                          </p>
                        ),
                      )}
                  </div>

                  <div className="statBlock">
                    <h4>Пол:</h4>
                    {statistics &&
                      statistics.gender &&
                      Object.entries(statistics.gender).map(([key, value]) => (
                        <p>
                          {key === "True" ? "Мужской" : "Женский"}: {value}
                        </p>
                      ))}
                  </div>
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={(е) => setDialogOpen(false)} color="primary">
              Закрыть
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <AccordionDetails className="AccordionDetails">
        <TableContainer component={Paper}>
          <Table
            sx={{ minWidth: 700 }}
            aria-label="customized table"
            className="mainTableCreate"
          >
            <TableHead>
              <TableRow>
                <StyledTableCell align="left">Дата установки </StyledTableCell>
                {/* {args.type === 'law' && */}
                {true && (
                  <StyledTableCell align="left">Дата платежа </StyledTableCell>
                )}
                <StyledTableCell align="left">Договор </StyledTableCell>
                {args.type === "law" && (
                  <StyledTableCell align="left">Компания </StyledTableCell>
                )}
                <StyledTableCell align="left">ФИО</StyledTableCell>
                <StyledTableCell align="left">Телефон</StyledTableCell>
                <StyledTableCell align="left">Почта</StyledTableCell>
                {args.type !== "law" && (
                  <StyledTableCell align="left">Пол</StyledTableCell>
                )}
                {args.type !== "law" && (
                  <StyledTableCell align="left">Район</StyledTableCell>
                )}
                <StyledTableCell align="left">Адрес </StyledTableCell>
                {args.type !== "law" && (
                  <StyledTableCell align="left">Трафик</StyledTableCell>
                )}
              </TableRow>
            </TableHead>

            <TableBody className="tableBody">
              <StyledTableRow className="dataRow dataRowCreate">
                <StyledTableCell className="skiny tableCell datepicker-box-create">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DateTimePicker"]}>
                      <DatePicker
                        className="datetimepicker"
                        format="DD/MM/YYYY"
                        ampm={false}
                        value={dayjs(install_time)}
                        id="install_time"
                        onChange={(e) =>
                          setInstall_time(
                            e ? `${e.$y}-${e.$M + 1}-${e.$D}` : null,
                          )
                        }
                        label="Дата установки"
                        slotProps={{
                          textField: {
                            error: errors.install_time,
                          },
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </StyledTableCell>

                {/* {args.type === 'law' && */}
                {true && (
                  <StyledTableCell className="skiny tableCell datepicker-box-create">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DateTimePicker"]}>
                        <DatePicker
                          className="datetimepicker"
                          format="DD/MM/YYYY"
                          ampm={false}
                          value={dayjs(schedule_time)}
                          id="schedule_time"
                          onChange={(e) =>
                            setSchedule_time(
                              e ? `${e.$y}-${e.$M + 1}-${e.$D}` : null,
                            )
                          }
                          label="Дата платежа"
                          slotProps={{
                            textField: {
                              error: errors.schedule_time,
                            },
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </StyledTableCell>
                )}

                <StyledTableCell
                  className="skiny tableCell"
                  sx={{ width: "200px" }}
                >
                  {args.type === "law" ? (
                    <InputMask
                      mask={userMask}
                      formatChars={{ "*": "[0-9/ ]" }}
                      value={user}
                      sx={{ width: "100%" }}
                      onChange={(e) => userCodeHandler(e)}
                    >
                      {() => (
                        <TextField
                          onfo
                          error={userTarifValidation || errors.user}
                          id="user-basic"
                          label="Договор"
                          variant="outlined"
                        />
                      )}
                    </InputMask>
                  ) : args.type === "RZN-S-" ? (
                    <InputMask
                      mask={`${args.type}*****`}
                      formatChars={{ "*": "[0-9]" }}
                      value={user}
                      sx={{ width: "100%" }}
                      onChange={(e) => userCodeHandler(e)}
                    >
                      {() => (
                        <TextField
                          onfo
                          error={userTarifValidation || errors.user}
                          id="user-basic"
                          label="Договор"
                          variant="outlined"
                        />
                      )}
                    </InputMask>
                  ) : (
                    <InputMask
                      mask={`${args.type.replace("so", "СО")}№*********`}
                      formatChars={{ "*": "[0-9/ ]" }}
                      value={user}
                      sx={{ width: "100%" }}
                      onChange={(e) => userCodeHandler(e)}
                    >
                      {() => (
                        <TextField
                          onfo
                          error={userTarifValidation || errors.user}
                          id="user-basic"
                          label="Договор"
                          variant="outlined"
                        />
                      )}
                    </InputMask>
                  )}
                </StyledTableCell>
                {args.type === "law" && (
                  <StyledTableCell className="skiny tableCell">
                    <TextField
                      value={company}
                      sx={{ width: "100%" }}
                      onChange={(e) => setCompany(e.target.value)}
                      onfo
                      id="name-basic"
                      label="Компания"
                      variant="outlined"
                      error={errors.name}
                    />
                  </StyledTableCell>
                )}

                <StyledTableCell className="skiny tableCell">
                  <TextField
                    value={name}
                    sx={{ width: "100%" }}
                    onChange={(e) => setName(e.target.value)}
                    onfo
                    id="name-basic"
                    label="ФИО"
                    variant="outlined"
                    error={errors.name}
                  />
                </StyledTableCell>

                <StyledTableCell
                  className="skiny tableCell"
                  sx={{ width: "175px" }}
                >
                  <InputMask
                    mask="9 (999) 999-99-99"
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                  >
                    {() => (
                      <TextField
                        sx={{ width: "100%" }}
                        id="number-basic"
                        label="Телефон"
                        variant="outlined"
                        error={errors.number}
                      />
                    )}
                  </InputMask>
                </StyledTableCell>

                <StyledTableCell
                  className="skiny tableCell"
                  sx={{ width: args.type !== "law" ? "350px" : "350px" }}
                >
                  <TextField
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onfo
                    id="email-basic"
                    label="Почта"
                    variant="outlined"
                    sx={{ width: "100%" }}
                    error={errors.email}
                  />
                </StyledTableCell>
                {args.type !== "law" && (
                  <StyledTableCell className="skiny tableCell select-box">
                    <Select
                      className="gender-select select"
                      value={gender}
                      label="Пол"
                      sx={{ width: "100%" }}
                      onChange={(e) => setGender(e.target.value)}
                    >
                      <MenuItem value={true}>муж</MenuItem>
                      <MenuItem value={false}>жен</MenuItem>
                    </Select>
                  </StyledTableCell>
                )}
                {args.type !== "law" && (
                  <StyledTableCell
                    className="skiny tableCell select-box"
                    sx={{ width: "230px" }}
                  >
                    <Select
                      className="location-select select"
                      value={location}
                      label="Район"
                      sx={{ width: "100%" }}
                      onChange={(e) => setLocation(e.target.value)}
                      error={errors.location}
                    >
                      <MenuItem value={"Московский"}>Московский </MenuItem>
                      <MenuItem value={"Железнодорожный"}>
                        Железнодорожный
                      </MenuItem>
                      <MenuItem value={"Советский"}>Советский</MenuItem>
                      <MenuItem value={"Октябрьский"}>Октябрьский</MenuItem>
                      <MenuItem value={"Ряз. Область"}>Ряз. Область </MenuItem>
                    </Select>
                  </StyledTableCell>
                )}

                <StyledTableCell
                  className="skiny tableCell"
                  sx={{ width: args.type !== "law" ? "350px" : "auto" }}
                >
                  <TextField
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    onfo
                    sx={{ width: "100%" }}
                    id="adress-basic"
                    label="Адрес"
                    variant="outlined"
                    error={errors.address}
                  />
                </StyledTableCell>
                {args.type !== "law" && (
                  <StyledTableCell className="skiny tableCell select-box">
                    <Select
                      id="demo-refferal-select"
                      className="refferal-select select"
                      value={referral}
                      label="Трафик"
                      onChange={(e) => setReferral(e.target.value)}
                      error={errors.referral}
                    >
                      <MenuItem value={"Рекомендация"}>Рекомендация</MenuItem>
                      <MenuItem value={"Рассылка СМС"}>Рассылка СМС</MenuItem>
                      <MenuItem value={"ВКонтакте"}>ВКонтакте</MenuItem>
                      <MenuItem value={"Расклейка"}>Расклейка</MenuItem>
                      <MenuItem value={"Сарафан"}>Сарафан</MenuItem>
                      <MenuItem value={"Лифты"}>Лифты</MenuItem>
                      <MenuItem value={"Интернет"}>Интернет</MenuItem>
                      <MenuItem value={"ТВ"}>ТВ</MenuItem>
                      <MenuItem value={"Радио"}>Радио</MenuItem>
                      <MenuItem value={"Билборды"}>Билборды</MenuItem>
                      <MenuItem value={"Звонки"}>Звонки</MenuItem>
                      <MenuItem value={"Спонсор"}>Спонсор</MenuItem>
                    </Select>
                  </StyledTableCell>
                )}
              </StyledTableRow>
            </TableBody>
          </Table>

          <div className="clientCreateButtonDiv">
            <Button
              onClick={createClientFunc}
              className="clientCreateButton"
              variant="contained"
            >
              Создать
            </Button>
          </div>

          {notification && <Alert severity="error">{notification}</Alert>}
        </TableContainer>
      </AccordionDetails>
    </Accordion>
  );
};

export default Create;
